"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDeclinedTransactionMessage = void 0;
const enums_1 = require("../../global/enums");
const internal_1 = require("../contracts/internal");
const getDeclinedTransactionMessage = (response) => {
    var _a;
    if (!('language' in response)) {
        return;
    }
    const language = (_a = response.language) !== null && _a !== void 0 ? _a : enums_1.Language.ENGLISH;
    const dictionary = internal_1.ReceiptDictionary[language];
    if (!('_processor' in response)) {
        return dictionary.ExtraLabels.declined;
    }
    let message = dictionary.ExtraLabels.declined;
    const { expressResponseMessage, logs } = response._processor;
    if (expressResponseMessage) {
        return expressResponseMessage;
    }
    const logMessage = logs.join('/n').toLocaleLowerCase();
    if (logMessage.includes('swiped card is chip capable. please insert card.')) {
        message = dictionary.ExtraLabels.insertCard;
    }
    if (logMessage.includes('transaction has timed out')) {
        message = dictionary.ExtraLabels.transactionTimedOut;
    }
    if (logMessage.includes('pin pad error')) {
        message = dictionary.ExtraLabels.pinPadError;
    }
    if (logMessage.includes('one or more errors occurred')) {
        message = dictionary.ExtraLabels.oneOrMoreError;
    }
    if (logMessage.includes('unable to find pin pad')) {
        message = dictionary.ExtraLabels.unablePinpad;
    }
    if (logMessage.includes('card removed')) {
        message = dictionary.ExtraLabels.cardRemoved;
    }
    if (logMessage.includes('the transaction was approved online but declined by card after online processing')) {
        message = dictionary.ExtraLabels.processingError;
    }
    return message;
};
exports.getDeclinedTransactionMessage = getDeclinedTransactionMessage;
//# sourceMappingURL=getDeclinedTransactionMessage.js.map